import { render, staticRenderFns } from "./Pl.vue?vue&type=template&id=4312daec&scoped=true&"
import script from "./Pl.vue?vue&type=script&lang=js&"
export * from "./Pl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4312daec",
  null
  
)

export default component.exports